import { Card, CardContent, Grid } from '@mui/material'
import React from 'react'
import summitLogo from './../../images/summitlogo@2x.webp'
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <Card sx={{ 
            width: "100%", 
            background: " linear-gradient(to right, #e0eafc, #cfdef3); " 
        }}>
            <CardContent>
                <Grid container justifyContent={"space-around"}>
                    <Grid item>
                        <Link to="/privacy">Privacy policy</Link>
                    </Grid>
                    <Grid item>
                        <Link to="/terms">Terms of use</Link>
                    </Grid>
                    <Grid item>
                        <Link to="/refund">Refund policy</Link>
                    </Grid>
                    <Grid item>
                        <img
                            className="logo-1-icon"
                            loading="eager"
                            alt=""
                            src={summitLogo}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default Footer
